/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Signup_PromptInputs */

const he_auth_signup_prompt = /** @type {(inputs: Auth_Signup_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`אין לכם חשבון?`)
};

const en_auth_signup_prompt = /** @type {(inputs: Auth_Signup_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Don't have an account?`)
};

/**
* | output |
* | --- |
* | "Don't have an account?" |
*
* @param {Auth_Signup_PromptInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const auth_signup_prompt = /** @type {((inputs?: Auth_Signup_PromptInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Signup_PromptInputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_auth_signup_prompt(inputs)
	return en_auth_signup_prompt(inputs)
});